/* ── Dining Module Constants ─────────────────────────────────────── */

import type { SeatingPreference } from '../types/dining.types';

export const SEATING_OPTIONS: { label: string; value: SeatingPreference }[] = [
  { label: 'Indoor', value: 'Indoor' },
  { label: 'Outdoor', value: 'Outdoor' },
  { label: 'Window', value: 'Window' },
  { label: 'Private Room', value: 'Private' },
  { label: 'Bar Seating', value: 'Bar' },
];

export const GUEST_COUNT_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const OCCASION_OPTIONS = [
  { label: 'Select occasion (optional)', value: '' },
  { label: 'Birthday', value: 'Birthday' },
  { label: 'Anniversary', value: 'Anniversary' },
  { label: 'Business Dinner', value: 'Business Dinner' },
  { label: 'Casual', value: 'Casual' },
  { label: 'Date Night', value: 'Date Night' },
  { label: 'Family', value: 'Family' },
  { label: 'Other', value: 'Other' },
];

/* ── Table Reservation Charge Config (for non-hotel-guests) ─────── */

export const TABLE_RESERVE_CHARGE = {
  enabled: true,
  chargeType: 'per-person' as const,
  fixedAmount: 500,
  perPersonAmount: 200,
  peakEnabled: true,
  peakSurcharge: 50,
  cancellationWindow: 4,
  cancellationFeePercent: 50,
  noShowFeePercent: 100,
};

/* ── Translation Key Maps ───────────────────────────────────────────── */

export const SEATING_KEYS: Record<string, string> = {
  'Indoor': 'dining.seatingOptions.indoor',
  'Outdoor': 'dining.seatingOptions.outdoor',
  'Window': 'dining.seatingOptions.window',
  'Private Room': 'dining.seatingOptions.privateRoom',
  'Bar Seating': 'dining.seatingOptions.barSeating',
};

export const OCCASION_KEYS: Record<string, string> = {
  'Select occasion (optional)': 'dining.occasionOptions.selectOccasion',
  'Birthday': 'dining.occasionOptions.birthday',
  'Anniversary': 'dining.occasionOptions.anniversary',
  'Business Dinner': 'dining.occasionOptions.businessDinner',
  'Casual': 'dining.occasionOptions.casual',
  'Date Night': 'dining.occasionOptions.dateNight',
  'Family': 'dining.occasionOptions.family',
  'Other': 'dining.occasionOptions.other',
};

export const DINING_TAB_KEYS: Record<string, string> = {
  'all': 'dining.tabs.all',
  'Upcoming': 'dining.tabs.upcoming',
  'Completed': 'dining.tabs.completed',
  'Cancelled': 'dining.tabs.cancelled',
};

export const RESERVATION_STATUS_KEYS: Record<string, string> = {
  Confirmed: 'dining.reservationStatus.confirmed',
  Completed: 'dining.reservationStatus.completed',
  Cancelled: 'dining.reservationStatus.cancelled',
};

export const DINING_TAB_LABELS: Record<string, string> = {
  all: 'dining.tabs.all',
  Confirmed: 'dining.tabs.upcoming',
  Completed: 'dining.tabs.completed',
  Cancelled: 'dining.tabs.cancelled',
};
